<template>
  <Navigation :currentPage="'download'" />
  <div id="videoHeader">
    <video
      src="@/assets/video/download_header.mp4" 
      autoplay
      muted
      loop
    >
    您的浏览器不支持 HTML5 视频标签。
    </video>
  </div>
  <div class="download">
    <div class="notes">
      <h1>模型放入场景，总共需几步？</h1>
      <h1 id="autoUp">第1步：点一下。</h1>
      <h1 id="autoUp">没有然后。</h1>
      <div class="circle">就&nbsp;1&nbsp;步</div>
      <div class="triangle"></div>
    </div>

    <PluginsList/>
    <UserGuide/>
    <KuFooter/>
  </div>
</template>

<script>
// @ is an alias to /src
import Navigation from '@/components/Navigation.vue'
import PluginsList from '@/components/PluginsList.vue'
import UserGuide from '@/components/UserGuide.vue'
import KuFooter from '@/components/KuFooter.vue';

export default {
  name: 'DownloadView',
  components: {
    Navigation,
    PluginsList,
    UserGuide,
    KuFooter,
  }
}
</script>

<style>

.download{
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  min-width: 1024px;
}

.videoHeader{
  margin: 0 auto;
  text-align: center;
  position: relative;
  overflow: hidden;
}

#videoHeader video {
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  object-fit: cover;
}

.notes{
  width: 100%;
  background-color: rgb(250, 250, 250);
  padding: 160px 0 160px 0;
  margin-bottom: 48px;
  color: #45B5B5;
}

.notes h1{
  font-size: 72px;
  font-weight: lighter;
}

.notes h2{
  font-weight: 400;
  color: lightgray;
}

.notes *{
  text-align: center;
  line-height: 128px;
}

.circle{
  width: 250px;
  height: 250px;
  margin: 36px auto;
  border-radius: 50%;
  background-color: #45B5B5;
  color: white;
  font-size: 72px;
  line-height: 250px;
  font-weight: 100;
  user-select: none;
}

.triangle{
  margin: 0 auto;
  width: 0;
  height: 0;
  border-left: 50px solid transparent;
  border-right: 50px solid transparent;
  border-top: 50px solid #45B5B5;
}

</style>
